Array.prototype.keyBy = function(id){
  const dict = {};
  for(let item of this){
    dict[item[id]]=item;
  }
  return dict;
};

//English to Persian digits using unicode.
String.prototype.toFaDigits= function() {
  return this.replace(/\d/g, d => String.fromCharCode('0x06F'+d));
};

//English to Arabic digits using unicode.
String.prototype.toArDigits= function() {
  return this.replace(/\d/g, d => String.fromCharCode('0x066'+d));
};